import {UIService} from "../UIService";
import {ProductDataService} from "../../services/productDataService";
import {ProductDataStore} from "../../stores/productDataStore";
import {ColorService} from "./colorService";
import {AppStateService} from "../../services/appStateService";
import {EventService} from "../../services/eventService";
import {GlazingPackageService} from "../glazingPackageComponent/glazingPackageService";
import Cookies from "js-cookie";

export class ColorUIService {
    private uiService: UIService;
    private productDataService: ProductDataService;
    private productDataStore: ProductDataStore;
    private colorService: ColorService;
    private glazingPackageService: GlazingPackageService;
    private appStateService: AppStateService;
    private eventService: EventService;
    private outsideActive: boolean = true;

    constructor() {
        this.uiService = new UIService();
        this.productDataService = new ProductDataService();
        this.productDataStore = new ProductDataStore();
        this.colorService = new ColorService();
        this.glazingPackageService = new GlazingPackageService();
        this.appStateService = new AppStateService();
        this.eventService = new EventService();

        this.populatePreview();
    }

    private populatePreview()
    {
        const selectedInsideColorElements = this.uiService.getElementByActionName('selected-insideColor');
        const selectedOutsideColorElements = this.uiService.getElementByActionName('selected-outsideColor');

        const selectedInnerColor = this.productDataStore.getSelectedOption('inner', 'color');
        const selectedOuterColor = this.productDataStore.getSelectedOption('outer', 'color');

        var insideColorPreviewElement = document.createElement('p');
        var outsideColorPreviewElement = document.createElement('p');

        insideColorPreviewElement.appendChild(
            document.createTextNode(
                selectedInnerColor.attributes.name
            )
        );
        outsideColorPreviewElement.appendChild(
            document.createTextNode(
                selectedOuterColor.attributes.name
            )
        );

        selectedInsideColorElements.forEach((element) => {
            this.uiService.removeHtmlInElement(element);
            this.uiService.addHtmlInElement(
                element,
                insideColorPreviewElement.innerHTML
            );
        });
        selectedOutsideColorElements.forEach((element) => {
            this.uiService.removeHtmlInElement(element);
            this.uiService.addHtmlInElement(
                element,
                outsideColorPreviewElement.innerHTML
            );
        });
    }

    public initializeColorComponent() {
        const selectedInnerColor = this.productDataStore.getSelectedOption('inner', 'color');
        const selectedOuterColor = this.productDataStore.getSelectedOption('outer', 'color');

        this.setOutsideColorPreview(selectedOuterColor);
        this.setInsideColorPreview(selectedInnerColor);
        this.refreshPriceInPreview();

        if (this.colorService.canChangeColor) {
            let outsideColorPalettes = this.colorService.getOutsidePalettes();
            let insideColorPalettes = this.colorService.getInsidePalettes();
            let doorColorSetBasedOnCookie = this.setDoorColorBasedOnCookie();

            this.initializeColorPalettes(outsideColorPalettes, insideColorPalettes);
            this.initializeDefaultColorsForEntranceDoors();
            this.initializeSearchBar();
            // this.activateOutsidePreview();
            // this.initializePredefinedCombinations();

            if (doorColorSetBasedOnCookie) {
                this.eventService.emit('reloadDoorDrawing');
            }

            this.eventService.getTarget().addEventListener('reloadDrawing', (data) => {
                this.colorService.validateDimensionColorRule();
                this.setColorsInPalette();
            });

            this.eventService.getTarget().addEventListener('updateColorPrices', (data) => {
                this.refreshPriceInPreview();
            });

            // const resetButton = this.uiService.getResetButtonByModule('color');
            // resetButton.addEventListener('click', this.resetSelectedOptions.bind(this));
        } else {
            this.hideColorSelector();
        }
    }

    private resetSelectedOptions()
    {
        this.colorService.resetSelectedOptions();
        let selectedOutsideColor = this.productDataStore.getSelectedOption('outer', 'color');
        let selectedInsideColor = this.productDataStore.getSelectedOption('inner', 'color');

        this.activateOutsidePreview();
        this.setOutsideColorPreview(selectedOutsideColor);
        this.setInsideColorPreview(selectedInsideColor);
        this.refreshPriceInPreview();
        this.eventService.emit('colorChange');
    }

    private activateOutsidePreview() {
        this.appStateService.setAppSettingTemplateFlag('colors', 'outsidePaletteContainer', true);
        this.appStateService.setAppSettingTemplateFlag('colors', 'insidePaletteContainer', false);
        this.uiService.refreshElementsInModule('colors');
        this.uiService.setSelectedOption(this.uiService.getElementByAttribute('nf-template-action', 'outsideColorPreview'));
        this.uiService.resetSelection([this.uiService.getElementByAttribute('nf-template-action', 'insideColorPreview')]);
        this.outsideActive = true;
        this.refreshSearchBar();
        this.setColorsInPalette();
        this.uiService.moveElement('color-selector', 'color-selector-outside-anchor');
    }

    private activateInsidePreview() {
        this.appStateService.setAppSettingTemplateFlag('colors', 'outsidePaletteContainer', false);
        this.appStateService.setAppSettingTemplateFlag('colors', 'insidePaletteContainer', true);
        this.uiService.refreshElementsInModule('colors');
        this.uiService.setSelectedOption(this.uiService.getElementByAttribute('nf-template-action', 'insideColorPreview'));
        this.uiService.resetSelection([this.uiService.getElementByAttribute('nf-template-action', 'outsideColorPreview')]);
        this.outsideActive = false;
        this.refreshSearchBar();
        this.setColorsInPalette();
        this.uiService.moveElement('color-selector', 'color-selector-inside-anchor');
    }

    private initializePredefinedCombinations() {
        const predefinedCombinations = this.productDataStore.getAvailableOptionsByName('predefinedCombination');

        if (predefinedCombinations.length > 0) {
            const colors = this.productDataStore.getAvailableOptionsByName('color');
            const predefinedCombinationsButton = this.uiService.getElementByAttribute('nf-template-action', 'predefinedCombinationsButton');
            const customCombinationsButton = this.uiService.getElementByAttribute('nf-template-action', 'customCombinationsButton');

            this.appStateService.setAppSettingTemplateFlag('colors', 'predefinedCustomSwitch', true);
            this.appStateService.setAppSettingTemplateFlag('colors', 'colorsPredefinedCombinationsContainer', true);
            this.appStateService.setAppSettingTemplateFlag('colors', 'colorsCustomContainer', false);
            this.appStateService.setAppSettingTemplateFlag('colors', 'outsidePaletteContainer', false);
            this.appStateService.setAppSettingTemplateFlag('colors', 'insidePaletteContainer', false);
            this.uiService.disableOption(this.uiService.getElementByAttribute('nf-template-action', 'outsideColorPreview'));
            this.uiService.disableOption(this.uiService.getElementByAttribute('nf-template-action', 'insideColorPreview'));

            this.uiService.setSelectedOption(predefinedCombinationsButton);
            this.uiService.resetSelection([customCombinationsButton]);

            this.uiService.refreshElementsInModule('colors');

            predefinedCombinations.forEach(combination => {
                const insideColor = colors.find(color => color.id === combination.relationships.colorInner.data.id);
                const outsideColor = colors.find(color => color.id === combination.relationships.colorOuter.data.id);
                const option = this.createPredefinedCombinationOption(insideColor, outsideColor);

                option.addEventListener('click', () => {
                    this.productDataService.updateSelectedOptionByName('predefinedCombination', combination.id, true);

                    this.productDataService.updateSelectedOptionByName('inner', insideColor.id);
                    this.setInsideColorPreview(insideColor);
                    this.productDataService.updateSelectedOptionByName('outer', outsideColor.id);
                    this.setOutsideColorPreview(outsideColor);

                    this.productDataService.updateSelectedOptionByName('seal', insideColor.attributes.sealColourId);
                    this.glazingPackageService.setDefaultGlazingSpacerColor(outsideColor.attributes.isWhite);

                    this.eventService.emit('reloadDrawing');
                    this.productDataService.refreshPrice();
                    this.eventService.emit('colorChange');
                });
            });

            predefinedCombinationsButton.addEventListener('click', () => {
                this.appStateService.setAppSettingTemplateFlag('colors', 'colorsPredefinedCombinationsContainer', true);
                this.appStateService.setAppSettingTemplateFlag('colors', 'colorsCustomContainer', false);

                if (this.outsideActive) {
                    this.appStateService.setAppSettingTemplateFlag('colors', 'outsidePaletteContainer', false);
                } else {
                    this.appStateService.setAppSettingTemplateFlag('colors', 'insidePaletteContainer', false);
                }

                this.uiService.disableOption(this.uiService.getElementByAttribute('nf-template-action', 'outsideColorPreview'));
                this.uiService.disableOption(this.uiService.getElementByAttribute('nf-template-action', 'insideColorPreview'));

                this.uiService.refreshElementsInModule('colors');
                this.uiService.setSelectedOption(predefinedCombinationsButton);
                this.uiService.resetSelection([customCombinationsButton]);
            });

            customCombinationsButton.addEventListener('click', () => {
                this.appStateService.setAppSettingTemplateFlag('colors', 'colorsPredefinedCombinationsContainer', false);
                this.appStateService.setAppSettingTemplateFlag('colors', 'colorsCustomContainer', true);

                if (this.outsideActive) {
                    this.appStateService.setAppSettingTemplateFlag('colors', 'outsidePaletteContainer', true);
                } else {
                    this.appStateService.setAppSettingTemplateFlag('colors', 'insidePaletteContainer', true);
                }

                this.uiService.enableOption(this.uiService.getElementByAttribute('nf-template-action', 'outsideColorPreview'));
                this.uiService.enableOption(this.uiService.getElementByAttribute('nf-template-action', 'insideColorPreview'));

                this.uiService.refreshElementsInModule('colors');
                this.uiService.setSelectedOption(customCombinationsButton);
                this.uiService.resetSelection([predefinedCombinationsButton]);
            });
        }
    }

    private initializeColorPalettes(outsideColorPalettes, insideColorPalettes) {
        if (outsideColorPalettes.length > 1) {
            outsideColorPalettes.forEach(palette => {
                const option = this.createOutsidePaletteOption(palette);

                option.addEventListener('click', this.switchPalette.bind(this, palette, 'outside'));
            });
        }

        if (insideColorPalettes.length > 1) {
            insideColorPalettes.forEach(palette => {
                const option = this.createInsidePaletteOption(palette);

                option.addEventListener('click', this.switchPalette.bind(this, palette, 'inside'));
            });
        }

        this.uiService.getElementByAttribute('nf-template-action', 'outsideColorPreview').addEventListener('click', this.activateOutsidePreview.bind(this));
        this.uiService.getElementByAttribute('nf-template-action', 'insideColorPreview').addEventListener('click', this.activateInsidePreview.bind(this));
    }

    private initializeSearchBar() {
        this.uiService.getElementByAttribute('nf-template-action', 'searchBar').addEventListener('keyup', (event: any) => {
            this.setColorsInPalette((this.outsideActive) ? this.colorService.selectedOutsidePalette.id : this.colorService.selectedInsidePalette.id, event.currentTarget.value);
        });

        this.refreshSearchBar();
    }

    private refreshSearchBar() {
        const selectedPalette = (this.outsideActive) ? this.colorService.selectedOutsidePalette : this.colorService.selectedInsidePalette;
        if (this.colorService.isPaletteNcs(selectedPalette)) {
            this.appStateService.setAppSettingTemplateFlag('colors', 'ncsSearchBar', true);
            this.appStateService.setAppSettingTemplateFlag('colors', 'customColorSearchBar', false);
        } else {
            this.appStateService.setAppSettingTemplateFlag('colors', 'ncsSearchBar', false);
            this.appStateService.setAppSettingTemplateFlag('colors', 'customColorSearchBar', true);
        }
        this.uiService.refreshElementsInModule('colors');
        this.resetSearchBar();
    }

    private initializeDefaultColorsForEntranceDoors() {
        if (this.colorService.shouldDefaultColorsBeDisplayed()) {
            const standardColors = this.productDataStore.getAvailableOptionsByName('standardColors');

            standardColors.forEach(color => {
                const option = this.createStandardColorsOption(color);

                option.addEventListener('click', this.setColorOption.bind(this, color));
            });
        }
    }

    private switchPalette(palette, side: 'outside' | 'inside') {
        if (side === 'outside') {
            this.colorService.selectedOutsidePalette = palette;
            this.refreshInsidePalettes();
        } else {
            this.colorService.selectedInsidePalette = palette;
        }

        this.refreshSearchBar();
        this.setColorsInPalette(palette.id);
    }

    private createOutsidePaletteOption(pallete): Element {
        const option = this.uiService.createConfiguratorOption('outsidePalette');

        this.uiService.addTextInElement(
            option,
            pallete.name
        );

        return option;
    }

    private createInsidePaletteOption(pallete): Element {
        const option = this.uiService.createConfiguratorOption('insidePalette');

        this.uiService.addTextInElement(
            option,
            pallete.name
        );

        return option;
    }

    private createColorOption(color) {
        const option = this.uiService.createConfiguratorOption('color');

        this.uiService.addTextInElement(
            option,
            (color.attributes.isRal) ? color.attributes.ral : color.attributes.name
        );

        const imgElement = this.uiService.getElementByAttribute('nf-value-key', 'img', option);
        const hexElement = this.uiService.getElementByAttribute('nf-value-key', 'hex', option);

        if (color.attributes.imgThumbSrc) {
            this.uiService.setAttributeToElement(
                imgElement,
                'src',
                color.attributes.imgThumbSrc
            );

            this.uiService.hideElement(hexElement);
        } else {
            this.uiService.setBackgroundColorToElement(
                hexElement,
                color.attributes.hex
            );

            this.uiService.hideElement(imgElement);
        }

        return option;
    }

    private createStandardColorsOption(color) {
        const option = this.uiService.createConfiguratorOption('standardColor');

        let colorName = color.attributes.name;

        if (color.attributes.isRal) {
            colorName = color.attributes.ralNumber;
        } else if (color.attributes.isNcs) {
            colorName = color.attributes.ncsNumber;
        }

        // this.uiService.addTextInElement(
        //     this.uiService.getElementByAttribute('nf-value-key', 'name', option),
        //     colorName
        // );

        const imgElement = this.uiService.getElementByAttribute('nf-value-key', 'img', option);
        const hexElement = this.uiService.getElementByAttribute('nf-value-key', 'hex', option);

        if (color.attributes.doorImgSrc) {
            this.uiService.setAttributeToElement(
                imgElement,
                'src',
                color.attributes.doorImgSrc
            );

            this.uiService.hideElement(hexElement);
        } else {
            this.uiService.setBackgroundColorToElement(
                hexElement,
                color.attributes.hex
            );

            this.uiService.hideElement(imgElement);
        }

        return option;
    }

    private createPredefinedCombinationOption(insideColor, outsideColor) {
        const option = this.uiService.createConfiguratorOption('predefinedCombination');

        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'nameInside', option),
            (insideColor.attributes.isRal) ? insideColor.attributes.ral : insideColor.attributes.name
        );

        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'nameOutside', option),
            (outsideColor.attributes.isRal) ? outsideColor.attributes.ral : outsideColor.attributes.name
        );

        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute('nf-value-key', 'imgInside', option),
            'src',
            insideColor.attributes.imgThumbSrc
        );

        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute('nf-value-key', 'imgOutside', option),
            'src',
            outsideColor.attributes.imgThumbSrc
        );

        return option;
    }

    private refreshInsidePalettes() {
        const insideColorPalettes = this.colorService.getInsidePalettes();

        this.uiService.removeElementsByPartName('insidePalettes');
        if (insideColorPalettes.length > 1) {
            insideColorPalettes.forEach(palette => {
                const option = this.createInsidePaletteOption(palette);

                option.addEventListener('click', this.switchPalette.bind(this, palette, 'inside'));
            });
        }
    }

    private setColorsInPalette(paletteId: any = null, searchKeyword: string = null) {
        //@ts-ignore
        searchKeyword = (searchKeyword) ? searchKeyword : this.uiService.getElementByAttribute('nf-template-action', 'searchBar').value;

        const colorsInPalette = this.colorService.getColorsInPalette(
            (this.outsideActive) ? 'outer' : 'inner',
            paletteId,
            searchKeyword
        );

        this.uiService.removeElementsByPartName('colors');
        colorsInPalette.forEach(color => {
            const option = this.createColorOption(color);

            option.addEventListener('click', this.setColorOption.bind(this, color));
        });
    }

    private setInsideColorFromMatchedPalette() {
        const colorPalettes = this.colorService.getInsidePalettes();
        const colors = this.productDataStore.getAvailableOptionsByName('color');

        const innerPalette = colorPalettes.filter(color => color.id === this.colorService.selectedCombination.relationships.paletteInner.data.id)[0];
        const colorsInPalette = colors.filter(el => el.attributes.paletteIds.indexOf(innerPalette.id) > -1)[0];

        if (colorsInPalette) {
            this.productDataService.updateSelectedOptionByName('inner', colorsInPalette.id);
            this.setInsideColorPreview(colorsInPalette);
        }
    }

    private setOutsideColorPreview(color) {
        const imgPreview = this.uiService.getElementByAttribute('nf-value-key', 'outsideColorPreviewImg');
        const hexPreview = this.uiService.getElementByAttribute('nf-value-key', 'outsideColorPreviewHex');

        if (color.attributes.imgSrc) {
            this.uiService.setAttributeToElement(
                imgPreview,
                'src',
                color.attributes.imgSrc
            );

            this.uiService.showElement(imgPreview);
            this.uiService.hideElement(hexPreview);
        } else {
            this.uiService.setBackgroundColorToElement(
                hexPreview,
                color.attributes.hex
            );

            this.uiService.showElement(hexPreview);
            this.uiService.hideElement(imgPreview);
        }

        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'outsideColorName'),
            color.attributes.name
        );

        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'outsideColorRal'),
            (color.attributes.isRal) ? `RAL ${color.attributes.ral}` : ''
        );

        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'outsideColorArticleNumber'),
            color.attributes.artNr
        );
    }

    private setInsideColorPreview(color) {
        const imgPreview = this.uiService.getElementByAttribute('nf-value-key', 'insideColorPreviewImg');
        const hexPreview = this.uiService.getElementByAttribute('nf-value-key', 'insideColorPreviewHex');

        if (color.attributes.imgSrc) {
            this.uiService.setAttributeToElement(
                imgPreview,
                'src',
                color.attributes.imgSrc
            );

            this.uiService.showElement(imgPreview);
            this.uiService.hideElement(hexPreview);
        } else {
            this.uiService.setBackgroundColorToElement(
                hexPreview,
                color.attributes.hex
            );

            this.uiService.showElement(hexPreview);
            this.uiService.hideElement(imgPreview);
        }

        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'insideColorName'),
            color.attributes.name
        );

        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'insideColorRal'),
            (color.attributes.isRal) ? `RAL ${color.attributes.ral}` : ''
        );

        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute('nf-value-key', 'insideColorArticleNumber'),
            color.attributes.artNr
        );
    }

    private setColorOption(color) {
        if (this.productDataService.isEntranceDoor()) {
            const defaultInnerColorId = this.productDataStore.getAttributeByName('defaultInnerColorId');

            if (!this.outsideActive && color.id === defaultInnerColorId) {
                this.productDataService.updateSelectedOptionByName('inner', color.id);
                this.setInsideColorPreview(color);
            } else {
                this.productDataService.updateSelectedOptionByName('inner', color.id);
                this.setInsideColorPreview(color);

                this.productDataService.updateSelectedOptionByName('outer', color.id);
                this.setOutsideColorPreview(color);

                this.productDataService.updateSelectedOptionByName('seal', color.attributes.sealColourId);
                this.glazingPackageService.setDefaultGlazingSpacerColor(color.attributes.isWhite);
            }
            this.productDataService.updateSelectedOptionByName('predefinedCombination', null, false);
            this.eventService.emit('reloadDoorDrawing');
        } else {
            if (this.outsideActive) {
                this.productDataService.updateSelectedOptionByName('outer', color.id);
                this.setOutsideColorPreview(color);
                this.glazingPackageService.setDefaultGlazingSpacerColor(color.attributes.isWhite);
                if (!this.colorService.matchCombinationWithSelectedOutsideColor()) {
                    this.setInsideColorFromMatchedPalette();
                    this.refreshInsidePalettes();
                }
            } else {
                this.productDataService.updateSelectedOptionByName('inner', color.id);
                this.productDataService.updateSelectedOptionByName('seal', color.attributes.sealColourId);
                this.setInsideColorPreview(color);
                this.colorService.matchCombinationWithSelectedOutsideColor();
            }
            this.productDataService.updateSelectedOptionByName('predefinedCombination', null, false);
            this.eventService.emit('reloadDrawing');
        }

        this.productDataService.refreshPrice();
        this.eventService.emit('colorChange');
        this.refreshPriceInPreview();
        this.populatePreview();
    }

    private refreshPriceInPreview() {
        const prices = this.colorService.calculateColorsPrice();
        const insideColorPrice = this.uiService.getElementByAttribute('nf-value-key', 'insideColorPrice');
        const outsideColorPrice = this.uiService.getElementByAttribute('nf-value-key', 'outsideColorPrice');

        this.uiService.replaceTextInElement(
            insideColorPrice,
            prices.inside + ' kr',
        );

        this.uiService.replaceTextInElement(
            outsideColorPrice,
            prices.outside + ' kr',
        );
    }

    private setDoorColorBasedOnCookie(): boolean {
        let configurationId = this.productDataStore.getData().data[0]['configurationId'];
        let colorId = Cookies.get(`default_config_color_${configurationId}`);

        if (!colorId) {
            return false;
        }

        this.productDataService.updateSelectedOptionByName('inner', colorId);
        this.productDataService.updateSelectedOptionByName('outer', colorId);

        let colorData = this.productDataStore.getAvailableOptionByNameAndId('color', colorId);
        this.setInsideColorPreview(colorData);
        this.setOutsideColorPreview(colorData);

        return true;
    }

    private hideColorSelector() {
        this.appStateService.setAppSettingTemplateFlag('colors', 'colorsPredefinedCombinationsContainer', false);
        this.appStateService.setAppSettingTemplateFlag('colors', 'colorsCustomContainer', false);
        this.uiService.refreshElementsInModule('colors');
    }

    private resetSearchBar() {
        //@ts-ignore
        this.uiService.getElementByAttribute('nf-template-action', 'searchBar').value = '';
    }
}
